<template>
<b-tab :title="$t('DOCUMENTWIN')" @click="getData()">
    <div class="">
        <div class="row mb-2">
            <div class="col-12">
                <button type="button" class="btn btn-primary button-add pull-right" @click="showModal()">{{$t('NEW')}}</button>
            </div>
        </div>
        <div class="row">
            <div class="card-body table-logoped" v-if="response.root != null">
                <grid
                    :data="response.root"
                    ref="documentKindergarden"
                    v-model="pagination"
                    :columns="columns"
                    :totalCount="response.totalCount"
                    gridId="documentKindergardenGrid">
                        <template v-slot="{item, column}">
                            <template v-if="column.id == 'actions'">
                                <b-link :href="item.docSrc" target="_blank" class="btn btn-primary button-view">View/Download</b-link>
                                <button type="button" class="btn button-dlt" @click="deleteRow(item.documentId)">{{$t('DELETE')}}</button>
                            </template>
                        </template>
                </grid>
            </div>
        </div>
        <b-modal ref="formmodal" :title="$t('DOCUMENTSFORM')" ok-title="submit" hide-footer no-close-on-backdrop size="lg">
        <div class="d-block">
            <documentform v-bind:formData="formData" v-bind:formError="formError" v-bind:isLoading="isLoading">
            </documentform>
        </div>
        <div class="text-right">
            <b-btn class="btn button-cancel mr-2" @click="hideModal()">{{$t('CANCEL')}}</b-btn>
            <b-btn class="btn button-save" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
        </div>
        </b-modal>
    </div>
</b-tab>
</template>

<script>
import Api from '@/api/child_kindergarten/ChildDocumentsKindergarten';
import DocumentForm from './DocumentForm.vue';

export default
{
    name: 'ChildDocumentsKindergarten',
    props: ['childKindergartenId'],
    components:
  {
      documentform: DocumentForm,
  },
    data()
    {
        const me = this;
        return {
            columns: [
                {
                    key: 'name',
                    name: me.$t('NAME'),
                },
                {
                    id: 'actions',
                    name: me.$t('ACTIONS'),
                },
            ],
            isLoading: false,
            response:
      {},
            formError:
      {},
            formData:
      {
          name: '',
          childKindergartenId: null,
      },
            pagination:
      {
          query: '',
          currentPage: 1,
          limit: 25,
          searchTimeout: false,
          initialId: null,
          sort: null,
          readingType: null,
      },
        };
    },
    created()
    {

    },
    methods:
  {
      async getData()
      {
          const me = this;
          try
          {
              const data = await Api.selectDocuments(me.getParams);
              if (data.error && data.error === true)
              {
                  me.$notify.notice(data);
                  me.loading = false;
                  return;
              }

              me.response = data;
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      async deleteRow(id)
      {
          const me = this;
          try
          {
              me.$store.commit('setModalAlert',
                  {
                      text: me.$i18n.t('AREYOUSHURE'),
                      async btnAction()
                      {
                          const data = await Api.deleteRow(
                              {
                                  id,
                              },
                          );
                          me.$notify.notice(data);
                          await me.getData();
                      },
                  });
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      showModal()
      {
          this.$refs.formmodal.show();
      },
      async submitData(item)
      {
          const me = this;
          me.isLoading = true;
          try
          {
              if (typeof item.arrivalRecordsId !== 'undefined')
              {
                  item.id = item.arrivalRecordsId;
                  delete (item.arrivalRecordsId);
              }

              item.childKindergartenId = me.childKindergartenId;

              const data = await Api.insertDocument(item);
              if (data.error)
              {
                  me.$notify.notice(data);
                  me.formError = data;
              }
              else
              {
                  me.$notify.notice(data);
                  me.hideModal();
                  await me.getData();
              }
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
          finally
          {
              me.isLoading = false;
          }
      },
      hideModal()
      {
          const me = this;
          this.$refs.formmodal.hide();

          me.formData = {
              name: '',
              childKindergartenId: null,
          };
      },
  },
    watch:
  {
      pagination:
    {
        deep: true,
        handler()
        {
            const me = this;

            if (me.searchTimeout !== false)
            {
                clearTimeout(me.searchTimeout);
            }

            me.searchTimeout = setTimeout(() =>
            {
                me.getData();
                me.searchTimeout = false;
            }, 300);
        },
    },
  },
    computed:
  {
      getParams()
      {
          const me = this;
          const data = {
              ...me.pagination,
          };
          data.start = (data.currentPage - 1) * data.limit;
          data.childKindergartenId = me.childKindergartenId;
          return data;
      },
  },
};
</script>
